import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "utils/axiosInstance";

export const useGetCustomerWalletBalanceQuery = ({ id }: { id: any }) => {
  return useQuery({
    queryKey: ["getCustomerWalletBalanceQuery", id],
    queryFn: () =>
      axiosInstance.get(`/customers/${id}/wallet`).then((res) => res.data),
  });
};
